import React from "react";
import { Container } from "@material-ui/core";

import EditUserDialog from "components/User/EditUser/EditUserDialog";
import UserTable from "./UserTable/UserTable";
import UsersOverview from "./UsersOverview";
import FilterBar from "./FilterBar";
import ConfirmationDialog from "./UserTable/ConfirmationDialog";
// import { useSelector } from "react-redux";
// import userActions from "./actions";

const UsersContainer = () => {
  // const { selectedTab } = useSelector((state) => state.user);
  // const { setTab } = userActions();
  return (
    <Container>
      <UsersOverview />
      <FilterBar />
      <UserTable />
      <EditUserDialog />
      <ConfirmationDialog />
    </Container>
  );
};

export default UsersContainer;
